// utils/printUtils.js

export const printHtmlContent = (htmlContent, options = {}) => {
    const {
      title = 'Print',
      logoUrl = '/logo192.png',
      header = '[Organization Name]',
      footer = '[Authorized Signature / Footer Note]',
      from = '',
      to = ''
    } = options;
  
    const printWindow = window.open('', '', 'width=900,height=700');
  
    printWindow.document.write(`
      <html>
        <head>
          <title>${title}</title>
          <style>
            @media print {
              @page {
                size: A4;
                margin: 1in;
              }
            }
            body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 40px;
              color: #000;
              position: relative;
              min-height: 100vh;
            }
  
            .logo-header {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-bottom: 20px;
            }
  
            .logo-header img {
              height: 60px;
              object-fit: contain;
              margin-right: auto;
            }
  
            .header-text {
              text-align: center;
              flex: 1;
              margin-right: 60px;
            }
  
            .statement-title {
              margin: 30px 0 10px 0;
              text-align: center;
              font-size: 18px;
              font-weight: bold;
            }
  
            table {
              width: 100%;
              border-collapse: collapse;
              font-size: 14px;
              margin-top: 20px;
            }
  
            th, td {
              border: 1px solid #444;
              padding: 8px;
              text-align: left;
            }
  
            footer {
              position: fixed;
              bottom: 40px;
              width: 100%;
              text-align: center;
              font-size: 12px;
              color: #666;
            }
          </style>
        </head>
        <body>
          <div class="logo-header">
            <img src="${logoUrl}" alt="Logo" />
            <div class="header-text">
              <h2>${header}</h2>
              ${from && to ? `<div class="statement-title">Statement from ${from} to ${to}</div>` : ''}
            </div>
          </div>
  
          <div class="content">
            ${htmlContent}
          </div>
  
          <footer>
            <p>Generated on ${new Date().toLocaleString()}</p>
            <p>${footer}</p>
          </footer>
        </body>
      </html>
    `);
  
    printWindow.document.close();
    printWindow.print();
  };
  